/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientNoteRequest
 */
export interface UpdateClientNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientNoteRequest
     */
    note?: string | null;
}

/**
 * Check if a given object implements the UpdateClientNoteRequest interface.
 */
export function instanceOfUpdateClientNoteRequest(value: object): value is UpdateClientNoteRequest {
    return true;
}

export function UpdateClientNoteRequestFromJSON(json: any): UpdateClientNoteRequest {
    return UpdateClientNoteRequestFromJSONTyped(json, false);
}

export function UpdateClientNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateClientNoteRequestToJSON(json: any): UpdateClientNoteRequest {
    return UpdateClientNoteRequestToJSONTyped(json, false);
}

export function UpdateClientNoteRequestToJSONTyped(value?: UpdateClientNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

